<template lang="html">
    <div>
        <!-- Top bar-->
        <main-header v-on:change-view="trigger"/>
        <!-- Begin Page Content -->
        <components v-bind:is="Content" v-on:change-view="trigger" :properties="properties" />
    </div>
</template>

<script>
    import Header from '@/views/Common/Header.vue'
    import Dashboard from '@/views/Dashboard/Dashboard.vue'

    function fetchBoardItems () {
        return new Promise((resolve, reject) => {
            this.$axios.get(this.$apiHost+'/board')
                .then(res => {
                    resolve(res.data.data);
                })
                //.catch(reissueAccessToken)
                .catch(()=>{
                    this.$store.dispatch('SIGNOUT');
                    window.location="/"})
        })
    }
    function reissueAccessToken (err) {
        return new Promise(resolve => {
            const previos = err.response.config.url;

            if (err.response.status === 401) {
                this.$axios.get(this.$apiHost+'/auth/reissuance')
                    .then(res => {
                        console.log(res);
                        this.$cookieJs.set('accessToken', res.data.data.accessToken);
                        this.$axios.defaults.headers.common['x-access-token'] = this.$cookieJs.get('accessToken');
                        this.$axios.get(previos)
                            .then(res => {
                                console.log(res);
                            });
                    });
            }
        })
    }
    export default {
        name: 'Main',
        components: 
        {  
            'main-header': Header,
            'main-dashboard': Dashboard,
        },
        created () {
        },
        mounted(){
            //화면 새로고침시 기존 화면 불러오기
            this.goPage({'id':sessionStorage.listid,'type':sessionStorage.type,'route':sessionStorage.route});
        },
        data () {
            return {
                Content: '',
                properties:[],
            }
        },
        methods: {
            goPage(data){
                this.Content = 'main-dashboard';
            },
            reissueToken (err) {
                const previos = err.response.config.url;
                if (err.response.status === 401) {
                    this.$axios.get(this.$apiHost+'/auth/reissuance')
                        .then(res => {
                            cookieJs.set('accessToken', res.data.data.accessToken);
                            this.$axios.defaults.headers.common['x-access-token'] = cookieJs.get('accessToken');
                            this.$axios.get(this.$apiHost+'/board')
                                .then(res => {
                                    console.log(res);
                                });
                        });
                }
            },
            trigger (data) {
                this.goPage(data);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/Common/Main.vue